<template>
  <div>
    <FormSignIn />
  </div>
</template>

<script>
import FormSignIn from "../templates/FormSignIn.vue";

export default {
  name: "SignIn",
  components: {
    FormSignIn,
  },
};
</script>